import * as yup from 'yup';

const REQUIRED_MESSAGE = 'Por favor, preencha este campo';

export const initialStepSchema = yup.object({
  name: yup.string().required(REQUIRED_MESSAGE),
  segmentId: yup.string().required(REQUIRED_MESSAGE),
  instructorIds: yup.array(yup.number()).nullable(),
  typeProgramId: yup.number().required(REQUIRED_MESSAGE),
  description: yup.string().nullable(),
});

export type InitialStepForm = yup.InferType<typeof initialStepSchema>;
